import { colors } from '../../../../../../../../../colorVars';
import { Body3 } from '../../../../../../../../../components/atomic/text/Text';

export function tooManySymbolsBuilder({parsedStatusObj}) {
  const { newCount, limit } = parsedStatusObj;

  return (
    <td>
      <Body3 fontWeight={500} color={colors.lightGrey}>
        Brokerage symbol limit of {limit ? limit : '1250'} has been reached.
        Symbols used: {newCount ? newCount : 'unknown'}.
      </Body3>
    </td>
  );
}
